module.exports = __webpack_public_path__ + "img/icon-goup.b7648aad.svg";